"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyPolicyCarData = void 0;
function makeEmptyPolicyCarData() {
    return {
        brandCode: '',
        brandDesc: '',
        modelCode: '',
        modelDesc: '',
        plate: '',
        carYear: '',
        serialMotor: '',
        carRegistry: '',
        amount: '',
        serialVin: '',
    };
}
exports.makeEmptyPolicyCarData = makeEmptyPolicyCarData;
//# sourceMappingURL=PolicyCarData.js.map